import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';

import ProposalDetail from './ProposalDetail';

class ProposalOverview extends React.Component {
  constructor(props) {
    super(props);
    this.handleRefreshRequest = this.handleRefreshRequest.bind(this);
  }
  componentWillMount() {
    this.props.requestProposals(this.props.tourId);
    this.props.requestBidsets(this.props.tourId)
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.detailTab !== this.props.detailTab) {
      this.props.requestBidsets(nextProps.tourId)
      this.props.requestProposals(nextProps.tourId);
    } else if (nextProps.needFetch) {
      this.props.requestBidsets(nextProps.tourId)
      this.props.requestProposals(nextProps.tourId);
    }
  }
  handleRefreshRequest(e) {
    this.props.requestProposals(this.props.tourId);
  }
  render() {
    if (this.props.needFetch || this.props.isFetching) {
      return <div>Loading...</div>;
    }
    if (this.props.proposals.length !== 0) {
      const proposalDetails = this.props.proposals.map(proposal => (
        <ProposalDetail
          key={proposal.id}
          addBidNote={this.props.addBidNote}
          editBid={this.props.editBid}
          proposal={proposal}
          removeBid={this.props.removeBid}
          sendBid={this.props.sendBid}
          sendProposal={this.props.sendProposal}
          user={this.props.user}
          tourData={this.props.tour}
          editMember={this.props.editMember}
          requestBidDetails={this.props.requestBidDetails}
          bidbidsDetails={this.props.bidbidsDetails}
          addHotelContact={this.props.addHotelContact}
          addBrandContact={this.props.addBrandContact}
          sendHotelBidRequests={this.props.sendHotelBidRequests}
          HotelContactDelete={this.props.HotelContactDelete}
          HotelContactUpdate={this.props.HotelContactUpdate}
          HotelBrandContactUpdate={this.props.HotelBrandContactUpdate}
          HotelBrandContactDelete={this.props.HotelBrandContactDelete}
        />
      ));
      return (
        <div>
          <div id="proposalOverviewInstruction">
          <p>You can send bid requests to a brand rep or to individual properties.</p>
          <p>
            Click on the{' '}
            <Button bsStyle="info" disabled>
              <i className="fa fa-pencil fa-lg" /> Edit Bid
            </Button>
            to see bid details, add notes for this property only, or send bid request directly to
            this property.
          </p>
          </div>
          {proposalDetails}
        </div>
      );
    }
    return (
      <div>
        No proposals are available. Please select hotels before trying to request bids.
        <Button onClick={this.handleRefreshRequest} bsStyle="primary">
          Refresh
        </Button>
      </div>
    );
  }
}

ProposalOverview.propTypes = {
  tourId: PropTypes.number.isRequired,
  proposals: PropTypes.arrayOf(PropTypes.object).isRequired,
  needFetch: PropTypes.bool.isRequired,
  addBidNote: PropTypes.func.isRequired,
  editBid: PropTypes.func.isRequired,
  removeBid: PropTypes.func.isRequired,
  requestProposals: PropTypes.func.isRequired,
  sendBid: PropTypes.func.isRequired,
  sendProposal: PropTypes.func.isRequired,
  tour: PropTypes.object,
  editMember: PropTypes.func,
};

ProposalOverview.defaultProps = {
  proposals: [],
};
export default ProposalOverview;



// WEBPACK FOOTER //
// src/routes/tours/components/ProposalOverview.js